export function resourceHead(title: string) {
  return {
    meta: [
      { title: `${title} · Softmax` },
      { name: "robots", content: "noindex, nofollow" },
    ],
  };
}
